// Base class for all models.
class Model extends Backbone.Model {

    // constructor(...args) {
    //     super(...args);
    //     this.toJSON = this.toJSON.bind(this);
    // }
    //
    // toJSON() {
    //     if (this._isSerializing) {
    //         return this.id || this.cid;
    //     } else {
    //         this._isSerializing = true;
    //         const json = _.clone(this.attributes);
    //         _.each(json, (value, name) => _.isFunction(value.toJSON) && (json[name] = value.toJSON()));
    //         this._isSerializing = false;
    //         return json;
    //     }
    // }

}

export default Model;



// WEBPACK FOOTER //
// ./app/models/Model.js